import { Mark } from './Mark';

if (typeof window !== 'undefined') {
  (window as any).Mark = Mark;
}

export { Mark };
export default Mark;


